module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/driver-ordering-portal.31fe586b.svg";